import { FC } from "react";
import { Button, Container, Modal, Row, Col } from "react-bootstrap";
import { ModalPropTypes } from "./types";
import QRCode from "qrcode.react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "redux/store";
import { selectSession } from "redux/selectors";
import style from "./style.module.scss";

export const QrModal: FC<ModalPropTypes> = (props) => {
  const { show, closeModal } = props;
  const { session } = useAppSelector(selectSession);
  let { guid } = useParams();

  return (
    <Modal
      show={show}
      scrollable
      centered
      fullscreen="sm-down"
      dialogClassName={style.modal}
    >
      <Modal.Header className="d-flex justify-content-center align-items-center border-bottom-0">
        <Modal.Title className="text-light fs-3 fw-bold text-center">
          {session?.Nome}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example">
        <Container>
          <Row>
            <Col>
              <h5 className="text-light">
                Per associare questo archivio al tuo smartphone:
              </h5>
              <ul>
                <li className="text-light fs-5">
                  se non l'hai già fatto, scarica <i>Danea Transfer</i> dall'App
                  Store (iOS) o dal Play Store (Android);
                </li>
                <li className="text-light fs-5">
                  avvia l'App e inquadra con la fotocamera il disegno
                  sottostante (QR Code).
                </li>
              </ul>
            </Col>
          </Row>
          <Row className="p-2">
            <QRCode value={guid ?? ""} size={180} level="H" renderAs="svg" />
          </Row>
          <Row>
            <Col>
              <h5 className="text-light">
                Se hai già abbinato uno o più archivi, per attivare la
                fotocamera dall'App fai clic sull'Archivio e quindi
                <i> Aggiungi archivio</i>.
              </h5>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center align-items-center border-top-0">
        <Button variant="outline-light px-4" onClick={closeModal}>
          Chiudi
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
